module.exports = __webpack_public_path__ + "static/media/arrowLeft.4c5cd6a5.svg";